<template>
  <div class="sc-chat-window" :class="{ opened: isOpen, closed: !isOpen }">
    <Header :title="title" :onClose="onClose" />
    <AccountInput v-if="!isMessageSent" :onSubmit="onInputSubmit" />
    <div class="send-success" v-if="isMessageSent">
      <img class="arrow-send" src="./assets/arrow-send.png" />
      <h4>{{ $t("feedback.thankYou") }}</h4>
      <p>{{ $t("feedback.messageWasSent") }}</p>
    </div>
  </div>
</template>

<script>
import Header from "./Header.vue";
import AccountInput from "./AccountInput.vue";

export default {
  components: {
    Header,
    AccountInput
  },
  props: {
    title: {
      type: String,
      required: true
    },
    onInputSubmit: {
      type: Function,
      required: true
    },
    onClose: {
      type: Function,
      required: true
    },
    isOpen: {
      type: Boolean,
      default: false
    },
    isMessageSent: {
      type: Boolean,
      required: true
    }
  }
};
</script>
<style lang="scss" scoped>
.send-success {
  padding: 14px;
  img {
    padding-bottom: 40px;
    max-width: 80%;
    margin: auto;
    display: block;
  }
}
.sc-chat-window {
  width: 370px;
  height: calc(100% - 120px);
  max-height: 470px;
  position: fixed;
  right: 25px;
  bottom: 100px;
  box-sizing: border-box;
  box-shadow: 0px 7px 40px 2px rgba(148, 149, 150, 0.1);
  background: white;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  transition: 0.3s ease-in-out;
  border-radius: 10px;
  font-family: "Helvetica Neue", Helvetica, Arial, sans-serif;
  z-index: 1000;
}

.sc-chat-window.closed {
  opacity: 0;
  visibility: hidden;
  bottom: 90px;
}

.sc-message--me {
  text-align: right;
}
.sc-message--them {
  text-align: left;
}

@media (max-width: 450px) {
  .sc-chat-window {
    width: 100%;
    height: 100%;
    max-height: 100%;
    right: 0px;
    bottom: 0px;
    border-radius: 0px;
  }
  .sc-chat-window {
    transition: 0.1s ease-in-out;
  }
  .sc-chat-window.closed {
    bottom: 0px;
  }
}
</style>
